import { day, formatCurrency } from '@vrplatform/utils';
import { Box, Group, HoverCard, Stack, Text } from '@mantine/core';

type PostingDatePreview = {
  hasMore: boolean;
  entries: {
    postingDate: string;
    amount: number;
  }[];
};

export const ReservationPostingDatePreviewTooltip = ({
  postingDatePreview,
  currency,
  children,
}: {
  postingDatePreview?: PostingDatePreview | null;
  currency: string | undefined;
  children: React.ReactNode;
}) => {
  const entries = postingDatePreview?.entries ?? [];
  const hasPreview = entries.length > 0;
  const showEllipsis = postingDatePreview?.hasMore && entries.length > 2;

  return (
    <HoverCard
      disabled={!hasPreview}
      withArrow
      shadow="md"
      position="left-start"
      openDelay={100}
    >
      <HoverCard.Target>
        <Box component="span">{children}</Box>
      </HoverCard.Target>
      <HoverCard.Dropdown p="xs" maw={220}>
        <Stack gap={6}>
          <Text size="xs" c="gray.6">
            Posting dates
          </Text>
          <Stack gap={2}>
            {entries.map((entry, index) => {
              const shouldShowEllipsis = showEllipsis && index === 2;

              return (
                <Box key={`${entry.postingDate}-${entry.amount}`}>
                  {shouldShowEllipsis && (
                    <Text size="xs" c="gray.6">
                      ...
                    </Text>
                  )}
                  <Group justify="space-between" gap="md" wrap="nowrap">
                    <Text size="xs" c="gray.6">
                      {day(entry.postingDate).format('D MMM, YYYY')}
                    </Text>
                    <Text size="xs" fw={500} ta="right">
                      {formatCurrency(entry.amount / 100, currency)}
                    </Text>
                  </Group>
                </Box>
              );
            })}
          </Stack>
        </Stack>
      </HoverCard.Dropdown>
    </HoverCard>
  );
};
